import axios from "axios";
export const auth = {
    state: {
        auth_status: false,
        auth_token: null,
        contract: {
            is_open: false,
            count: 0,
        },
        sidebar: {
            sidebarwidth: "18%",
            bgsidebar: "18%",
            expand: false,
        },
        auth_info: {
            id: null,
            name: null,
            nik: null,
            gender: null,
            email: null,
            phone: null,
            address: null,
            birth_date: null,
            birth_place: null,
            company: null,
            division: null,
            divkd: null,
            subdivision: null,
            subdivkd: null,
            department: null,
            position: null,
            photo: null,
            role: null,
            blood: null,
            joindate: null,
            access_token: null,
            permission: null,
        },
        auth_reset: false,
        masbarContract: [],
        contractHeader: {
            sup_kd: null,
            sup_nm: null,
            currency: null,
            divisi_kd: null,
            subdiv_kd: null,
            rate: null,
            top: null,
            start_date: null,
            end_date: null,
            note: null,
        },
        masbarReceiving: [],
        receivingHeader: {
            sup_kd: null,
            sup_nm: null,
            divisi_kd: null,
            subdiv_kd: null,
            delivery: null,
            poData: [],
            supDetail: {},
        },
        request_items: [],
        profileimage: null,
        location_request: null,
        department_request: null,
        distribution: {
            req_no: null,
            items: [],
        },
        requestEdit: [],
        invoices: [],
        tt_head: null,
    },
    getters: {
        GET_AUTH_TOKEN(state) {
            return state.auth_token;
        },

        GET_AUTH_INFO(state) {
            return state.auth_info;
        },

        GET_AUTH_RESET(state) {
            return state.auth_reset;
        },

        GET_SIDEBAR_WIDTH(state) {
            return state.sidebar;
        },

        GET_CONTRACT_NOTIF(state) {
            return state.contract;
        },

        GET_ITEMS_CONTRACT(state) {
            return state.masbarContract;
        },

        GET_CONTRACT_HEADER(state) {
            return state.contractHeader;
        },

        GET_RECEIVING_HEADER(state) {
            return state.receivingHeader;
        },

        GET_ITEMS_RECEIVING(state) {
            return state.masbarReceiving;
        },

        GET_PROFILE_IMAGE(state) {
            return state.profileimage;
        },

        GET_REQUEST_ITEM(state) {
            return state.request_items;
        },

        GET_DEPARTMENT_REQUEST(state) {
            return state.department_request;
        },

        GET_LOCATION_REQUEST(state) {
            return state.location_request;
        },

        GET_DISTRIBUTION(state) {
            return state.distribution;
        },

        GET_REQUEST_EDIT(state) {
            return state.requestEdit;
        },

        GET_INVOICES(state) {
            return state.invoices;
        },

        GET_TTHEAD(state) {
            return state.tt_head;
        },
    },

    actions: {
        LOGIN(context, loginData) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/login", loginData, {
                        skipAuthInterceptor: true,
                    })
                    .then((response) => {
                        context.commit("SET_AUTH_TOKEN", response.data.token);
                        context.commit("SET_AUTH_INFO", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        REFRESH(context) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/login", {
                        skipAuthInterceptor: true,
                    })
                    .then((response) => {
                        context.commit(
                            "SET_AUTH_TOKEN",
                            response.data.data.token
                        );
                        context.commit(
                            "SET_AUTH_INFO",
                            response.data.data.user
                        );
                        resolve(response);
                    })
                    .catch((error) => {
                        if (error?.response?.status === 401) {
                            context.commit("SET_AUTH_LOGOUT");
                        }
                        reject(error);
                    });
            });
        },

        FORGOT(context, forgotData) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/forgot", forgotData, {
                        skipAuthInterceptor: true,
                    })
                    .then((response) => {
                        context.commit("SET_AUTH_RESET");
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        RESET(context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/reset", payload, {
                        skipAuthInterceptor: true,
                    })
                    .then((response) => {
                        context.commit("SET_AUTH_RESET");
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        LOGOUT(context, data) {
            const clearLocal = () => {
                context.commit("SET_AUTH_LOGOUT");
                context.commit("CLEAR_CONTRACT_NOTIF");
                context.commit("CLEAR_ITEMS_CONTRACT", []);
                context.commit("CLEAR_CONTRACT_HEADER");
                context.commit("CLEAR_ITEMS_RECEIVING", []);
                context.commit("CLEAR_RECEIVING_HEADER");
            };

            return new Promise((resolve, reject) => {
                axios
                    .post("/logout", data, {
                        skipAuthInterceptor: true,
                    })
                    .then((response) => {
                        clearLocal();
                        resolve(response);
                    })
                    .catch((error) => {
                        clearLocal();
                        reject(error);
                    });
            });
        },
    },

    mutations: {
        SET_INVOICES(state, payload) {
            state.invoices = payload;
        },

        SET_TTHEAD(state, payload) {
            state.tt_head = payload;
        },

        SET_REQUEST_ITEM(state, payload) {
            state.request_items = payload;
        },

        CLEAR_REQUEST_ITEM(state) {
            state.request_items = [];
        },

        SET_REQUEST_EDIT(state, payload) {
            state.requestEdit.push(payload);
        },

        REMOVE_REQUEST_EDIT(state, payload) {
            state.requestEdit.splice(payload);
        },

        CLEAR_REQUEST_EDIT(state) {
            state.requestEdit = [];
        },

        SET_DISTRIBUTION(state, payload) {
            state.distribution.req_no = payload.req_no;
            state.distribution.items = payload.items;
        },

        CLEAR_DISTRIBUTION(state) {
            state.distribution.req_no = null;
            state.distribution.items = [];
        },

        SET_ITEMS_CONTRACT(state, payload) {
            state.masbarContract = payload;
        },

        CLEAR_ITEMS_CONTRACT(state, payload) {
            state.masbarContract = payload;
        },

        SET_CONTRACT_HEADER(state, payload) {
            state.contractHeader.sup_kd = payload.sup_kd;
            state.contractHeader.sup_nm = payload.sup_nm;
            state.contractHeader.currency = payload.currency;
            state.contractHeader.subdiv_kd = payload.subdiv_kd;
            state.contractHeader.divisi_kd = payload.divisi_kd;
            state.contractHeader.rate = payload.rate;
            state.contractHeader.top = payload.top;
            state.contractHeader.start_date = payload.start_date;
            state.contractHeader.end_date = payload.end_date;
            state.contractHeader.note = payload.note;
        },

        CLEAR_CONTRACT_HEADER(state) {
            state.contractHeader.sup_kd = null;
            state.contractHeader.sup_nm = null;
            state.contractHeader.currency = null;
            state.contractHeader.divisi_kd = null;
            state.contractHeader.subdiv_kd = null;
            state.contractHeader.rate = null;
            state.contractHeader.top = null;
            state.contractHeader.start_date = null;
            state.contractHeader.end_date = null;
            state.contractHeader.note = null;
        },

        SET_SIDEBAR_WIDTH(state, payload) {
            state.sidebar.sidebarwidth = payload.sidebar;
            state.sidebar.bgsidebar = payload.bg;
            state.sidebar.expand = payload.exp;
        },

        SET_AUTH_TOKEN(state, token) {
            state.auth_token = token;
            state.auth_status = Boolean(token);
        },

        SET_CONTRACT_NOTIF(state, payload) {
            state.contract.is_open = payload.is_open;
            state.contract.count = payload.count;
        },

        CLEAR_CONTRACT_NOTIF(state) {
            state.contract.is_open = null;
            state.contract.count = null;
        },

        SET_ITEMS_RECEIVING(state, payload) {
            state.masbarReceiving = payload;
        },

        CLEAR_ITEMS_RECEIVING(state, payload) {
            state.masbarReceiving = payload;
        },

        SET_RECEIVING_HEADER(state, payload) {
            state.receivingHeader.sup_kd = payload.sup_kd;
            state.receivingHeader.sup_nm = payload.sup_nm;
            state.receivingHeader.divisi_kd = payload.divisi_kd;
            state.receivingHeader.subdiv_kd = payload.subdiv_kd;
            state.receivingHeader.delivery = payload.delivery;
            state.receivingHeader.poData = payload.poData;
            state.receivingHeader.supDetail = payload.supDetail;
        },

        CLEAR_RECEIVING_HEADER(state) {
            state.receivingHeader.sup_kd = null;
            state.receivingHeader.sup_nm = null;
            state.receivingHeader.divisi_kd = null;
            state.receivingHeader.subdiv_kd = null;
            state.receivingHeader.delivery = null;
            state.receivingHeader.poData = [];
            state.receivingHeader.supDetail = {};
        },

        SET_PROFILE_IMAGE(state, payload) {
            state.auth_info.photo = payload.filename;
        },

        SET_PROFILE_IMAGE_FILE(state, payload) {
            state.profileimage = payload;
        },

        SET_AUTH_INFO(state, info) {
            state.auth_info.id = info.userid;
            state.auth_info.name = info.name;
            state.auth_info.nik = info.nik;
            state.auth_info.gender = info.gender;
            state.auth_info.email = info.email;
            state.auth_info.phone = info.phone;
            state.auth_info.address = info.address;
            state.auth_info.birth_date = info.birth_date;
            state.auth_info.birth_place = info.birth_place;
            state.auth_info.company = info.comp_kd;
            state.auth_info.division = info.div_nm;
            state.auth_info.divkd = info.divkd;
            state.auth_info.subdivision = info.subdiv_nm;
            state.auth_info.subdiv_kd = info.subdiv_kd;
            state.auth_info.department = info.dept_nm;
            state.auth_info.department_nama = info.dept_nama;
            state.auth_info.deptkd = info.deptkd;
            state.auth_info.position = info.grpname;
            state.auth_info.groupcode = info.grpcode;
            state.auth_info.photo = info.image;
            state.auth_info.role = info.roleId;
            state.auth_info.blood = info.blood;
            state.auth_info.joindate = info.createdAt;
            state.auth_info.access_token = info.token;
            state.auth_info.permission = info.mtext;
        },

        SET_AUTH_RESET(state) {
            state.auth_reset = true;
        },

        SET_DEPARTMENT_REQUEST(state, payload) {
            state.department_request = payload;
        },
        SET_LOCATION_REQUEST(state, payload) {
            state.location_request = payload;
        },
        SET_AUTH_LOGOUT(state) {
            state.auth_status = false;
            state.auth_token = null;
            state.auth_info = {
                id: null,
                name: null,
                nik: null,
                gender: null,
                email: null,
                phone: null,
                address: null,
                birth_date: null,
                birth_place: null,
                company: null,
                division: null,
                divkd: null,
                subdivision: null,
                subdivkd: null,
                subdiv_kd: null,
                department: null,
                department_nama: null,
                deptkd: null,
                position: null,
                groupcode: null,
                photo: null,
                role: null,
                blood: null,
                joindate: null,
                access_token: null,
                permission: null,
            };
        },
    },
};
